"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constant = require("../../styles/constant");
var _templateObject;
const Message = _styledComponents["default"].p(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  margin: ", ";\n  margin-top: ", ";\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n"])), (0, _constant.get)('space.0'), (0, _constant.get)('space.4'), (0, _constant.get)('colors.feedback.danger.normal'), (0, _constant.get)('space.14'), (0, _constant.get)('space.20'));
const Components = exports.Components = {
  Message
};